/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Accountability,
  BulbIcon,
  Hearthand,
  Lightning,
  LockIcon,
  Persons,
  ProfileIcon,
} from "./icon";

export interface COEProps {
  icon: any;
  heading: string;
  content: string[];
}

export const COEMockData = [
  {
    icon: Persons,
    heading: "Diversity & Equality",
    content: [
      "We strive to create an inclusive environment where all individuals feel valued, supported, and able to fully participate.",
      "We accept all participants in our coaching regardless of their appearance, gender, age, disability, race/ethnicity, religion, or sexual orientation.",
      "We respect and appreciate the diversity of individuals and groups, and recognize the value that diversity brings to the organization or community.",
    ],
  },

  {
    icon: Lightning,
    heading: "Integrity",
    content: [
      "We uphold moral and ethical principles in our coaching in such a way that we can give clients the assistance and guidance that will best meet their needs.",
      "We are honest and truthful in our actions and communication and act with integrity in all our coaching dealings.",
      "We make decisions based on ethical principles and values, and consider the impact of our actions on our clients.",
      "We are honest and truthful in our actions and communication and act with integrity in all our coaching dealings.",
    ],
  },

  {
    icon: Accountability,
    heading: "Accountability",
    content: [
      "We commit to demonstrating accountability in professional standards, legal compliance, and professional development.",
      "We serve to be an accountability partner to the clients and ensure that their commitments are taken seriously.",
      "We are responsible for our actions and decisions, and take steps to ensure that our coaching practices are safe, ethical, and consistent with the values of our profession.",
    ],
  },

  {
    icon: Hearthand,
    heading: "Empathy",
    content: [
      "We understand and validate our clients’ feelings and thoughts by providing emotional validation, support and guidance.",
      "We strive to understand our clients’ experiences and emotions and approach them with compassion and understanding.",
      "We are open to considering multiple perspectives and viewpoints, and be willing to listen and understand others' experiences and emotions.",
      "We strive to create a safe and supportive environment where clients feel comfortable sharing their thoughts and feelings.",
    ],
  },

  {
    icon: LockIcon,
    heading: "Confidentiality",
    content: [
      "We maintain confidentiality when dealing with client matters or discussions that may be considered sensitive or private.",
      "We handle records ethically and legally and use technology-assisted coaching services responsibly.",
      "If legal requirements dictate that authorities need to be informed of confidential concerns, the necessary information will be provided to them regardless of the client’s consent.",
      "We will immediately report the client to the appropriate authorities without hesitation if they engage in harm to themselves and/or others.",
      "We ensure that our clients fully understand the nature and purpose of our coaching relationship, and obtain their informed consent before proceeding.",
    ],
  },

  {
    icon: ProfileIcon,
    heading: "Professionalism",
    content: [
      "We clearly define and establish the scope of coaching and how it differs from other people-centered services.",
      "We establish clear boundaries for coaching while fulfilling our responsibilities as a coach.",
      "We conduct ourselves in a manner that is respectful, courteous, and professional at all times.",
      "We act in a way that reflects positively on the coaching profession and uphold the integrity of the profession.",
      "We maintain appropriate professional boundaries with our clients and avoid any relationships that could be perceived as inappropriate or exploitative.",
      "We manage conflicts of interest through agreements and communication, addressing roles, responsibilities, relationships, records, confidentiality, and reporting requirements.",
    ],
  },

  {
    icon: BulbIcon,
    heading: "Competence",
    content: [
      "We aspire to maintain the knowledge and skills required to provide effective coaching services and seek ongoing professional development to stay up-to-date with best practices.",
      "We will refer the client to appropriate licensed professionals if deemed necessary due to reasons beyond our expertise.",
      "We stay within the scope of our practice and do not offer services or advice outside of our areas of expertise.",
      "We strive in continuing education opportunities to maintain our knowledge and skills.",
      "We adhere to the standards and guidelines set forth by professional coaching associations.",
    ],
  },
];
